// material-ui
import { useTheme } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';

// assets
import { IconBell } from '@tabler/icons-react';

// types
import { ThemeMode } from '@app/types/config.ts';
import { useDashboardSelector } from '@hooks/useDashboard';

function NotificationSection() {
  const theme = useTheme();
  const toggleNotificationOpened = useDashboardSelector(
    (state) => state.toggleNotificationOpened
  );

  return (
    <>
      <Box sx={{ ml: 2 }}>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: 'all .2s ease-in-out',
            bgcolor:
              theme.palette.mode === ThemeMode.DARK
                ? 'dark.main'
                : 'secondary.light',
            color:
              theme.palette.mode === ThemeMode.DARK
                ? 'warning.dark'
                : 'secondary.dark',
            '&[aria-controls="menu-list-grow"],&:hover': {
              bgcolor:
                theme.palette.mode === ThemeMode.DARK
                  ? 'warning.dark'
                  : 'secondary.dark',
              color:
                theme.palette.mode === ThemeMode.DARK
                  ? 'grey.800'
                  : 'secondary.light',
            },
          }}
          onClick={toggleNotificationOpened}
          color="inherit"
        >
          <IconBell stroke={1.5} size="20px" />
        </Avatar>
      </Box>
    </>
  );
}

export default NotificationSection;
